import React from 'react';
import { FadeIn } from './Shared';
import { Gift } from 'lucide-react';
export const BonusesTable = () => {
  const bonuses = [{
    num: '01',
    name: 'Pack Estados que Llenan Turnos',
    desc: 'La biblioteca completa de estados listos para copiar y publicar en WhatsApp e Instagram. 46 textos organizados por situación: turno libre urgente, disponibilidad semanal, reactivación pasiva, seña y políticas, temporadas y fechas clave en Argentina. Nada genérico. Todo con llamado a la acción concreto y listo en menos de 2 minutos.',
    value: '$8.990'
  }, {
    num: '02',
    name: 'Guía Anti-Excusas para Cobrar Seña',
    desc: 'El manual de bolsillo para responder cada excusa frecuente sin ceder, sin enojarte y sin perder la venta. Las 32 excusas más comunes organizadas por categoría con respuesta exacta para cada una. Árbol de decisión completo, tabla de situaciones y frases que te hacen sonar fuerte vs. las que te hacen sonar débil. Listo para tener abierto al lado del chat.',
    value: '$6.990'
  }, {
    num: '03',
    name: 'Kit de Mensajes Copy-Paste para WhatsApp Beauty',
    desc: 'La biblioteca completa de mensajes listos para copiar, adaptar y enviar en cada situación real de tu negocio. 10 categorías, más de 80 mensajes: primera respuesta, precio con valor, horarios y cierre, cobro de seña, confirmación de turno, recordatorios, reprogramaciones, cancelaciones, seguimiento post-turno y reactivación. Con variantes específicas para manicura, lashes, cejas y estética facial.',
    value: '$7.990'
  }, {
    num: '04',
    name: 'Agenda Bajo Control',
    desc: 'El sistema de organización simple y aplicable para ordenar turnos, señas, seguimientos y reactivación desde el celular — sin apps de pago y sin tecnología sofisticada. Tablero semanal de turnos, tracker de señas, sistema de categorización de clientas, lista de espera activa, tracker de seguimiento, hoja de reactivación mensual y cierre semanal de agenda en 10 minutos. Con versión para cuaderno, notas del celular y Google Sheets.',
    value: '$6.990'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-16">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-17"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-18">
        <FadeIn data-id="element-19">
          <div className="text-center mb-16" data-id="element-20">
            <div className="inline-block bg-pink-500/10 text-pink-400 px-6 py-2 rounded-full text-xs font-bold tracking-[0.3em] mb-6 border border-pink-500/20 uppercase" data-id="element-21">
              REGALOS EXCLUSIVOS
            </div>
            <h2 className="text-3xl md:text-5xl flex items-center justify-center text-white tracking-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-22">
              <Gift className="w-10 h-10 text-pink-400 mr-6 shrink-0" data-id="element-23" />
              🎁 4 BONOS ESTRATÉGICOS
            </h2>
          </div>

          <div className="space-y-5 mb-12" data-id="element-24">
            {bonuses.map((bono, index) => <div key={index} className="bg-navy-950/60 rounded-3xl border border-white/5 p-6 md:p-8 flex flex-col gap-5 relative overflow-hidden hover:border-white/10 transition-colors" data-id="element-25">
                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-6" data-id="element-26">
                  <div className="flex items-start gap-5 md:gap-6" data-id="element-27">
                    <span className="text-3xl md:text-4xl font-black font-sans leading-none mt-1 text-pink-500" data-id="element-28">
                      {bono.num}
                    </span>
                    <div data-id="element-29">
                      <h3 className="text-lg md:text-xl font-sans font-bold text-white leading-tight mb-2.5" data-id="element-30">
                        {bono.name}
                      </h3>
                      <p className="text-gray-300 text-sm md:text-base leading-relaxed font-sans" data-id="element-31">
                        {bono.desc}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between sm:justify-end gap-4 sm:shrink-0 sm:mt-1" data-id="element-32">
                    <div className="flex flex-col sm:items-end gap-1.5" data-id="element-33">
                      <span className="text-gray-400 line-through text-xs md:text-sm font-bold" data-id="element-34">
                        {bono.value}
                      </span>
                      <span className="text-green-400 font-bold bg-green-400/10 px-4 py-1.5 rounded-full text-[10px] md:text-xs border border-green-400/20 tracking-widest uppercase" data-id="element-35">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-navy-800 via-navy-900 to-navy-950 rounded-3xl border border-pink-500/20 p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-8 relative overflow-hidden shadow-2xl" data-id="element-36">
            <div className="absolute top-0 right-0 -mt-12 -mr-12 w-48 h-48 bg-pink-500/10 rounded-full blur-3xl" data-id="element-37" />
            <div className="text-center md:text-left relative z-10" data-id="element-38">
              <p className="text-pink-400 uppercase tracking-[0.3em] text-[10px] md:text-xs font-bold mb-3 opacity-80" data-id="element-39">
                VALOR TOTAL DE LOS BONOS
              </p>
              <h4 className="text-2xl md:text-4xl font-bold text-white leading-tight font-[Montserrat,_sans-serif]" data-id="element-40">
                Todo esto es tuyo <br className="hidden md:block" data-id="element-41" />
                <span className="text-pink-400" data-id="element-42">sin costo extra</span>
              </h4>
            </div>
            <div className="text-center md:text-right relative z-10" data-id="element-43">
              <span className="text-white/40 line-through text-xl md:text-2xl font-bold block mb-2" data-id="element-44">
                $30.960
              </span>
              <span className="text-green-400 text-5xl md:text-7xl tracking-tighter font-[900] font-[Montserrat,_sans-serif]" data-id="element-45">
                GRATIS
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};